import React, { useContext } from 'react'
import { Equalizer, TrendingUp, Explore } from '@material-ui/icons/'
import listContext from '../../../Common/context/context'
import updatePropertyList from '../../Utility/UpdatePropertyList/UpdatePropertyList'

const SelectCompType = () => {

    const { propertyList, setPropertyList } = useContext(listContext)

    const handleModifyCompType = newCompType => {
        let fieldsToUpdate = []
        let omniViewPropertyListId = propertyList.omniViewPropertyListId
        let polarisPropertySearchCriteriaId = propertyList.polarisPropertySearchCriteriaId

        fieldsToUpdate.push({ key: 'omniViewPropertyListId', value: omniViewPropertyListId })
        fieldsToUpdate.push({ key: 'polarisPropertySearchCriteriaId', value: polarisPropertySearchCriteriaId })
        fieldsToUpdate.push({ key: 'compType', value: newCompType })

        const updatePropertyListObj = new updatePropertyList(fieldsToUpdate)
        updatePropertyListObj.update()

        let newPropertyList = { ...propertyList }
        newPropertyList.compType = newCompType
        setPropertyList(newPropertyList)

    }

    return (
        <>
            <div className="bg-white px-6 pt-6 pb-4">
                <div className="w-full">
                    <span className="font-medium form-control-lg">List type</span>
                </div>
                <div className="w-full flex flex-wrap md:flex-row py-4">
                    <button onClick={() => { handleModifyCompType('Rent') }} className={`btn btn-sm border-base mr-3 mb-4 ${propertyList.compType.toLowerCase() === 'rent' ? 'bg-gray-10 text-primary' : 'bg-white'}`} >
                        <span className="pl-2"><Equalizer fontSize="small" /></span>
                        <span className="px-4">Rent Comp</span>
                    </button>
                    {/* <button className="btn btn-sm border-base bg-white mr-3 mb-4">
                        <span className="pl-2"><Explore fontSize="small" /></span>
                        <span className="px-4">Portfolio - Rent Comp</span>
                    </button> */}
                    <button onClick={() => { handleModifyCompType('Sales') }} className={`btn btn-sm border-base mr-3 mb-4 ${propertyList.compType.toLowerCase() === 'sales' ? 'bg-gray-10 text-primary' : 'bg-white'}`}>
                        <span className="pl-2"><TrendingUp fontSize="small" /></span>
                        <span className="px-4">Sales Comp</span>
                    </button>
                </div>
            </div>
        </>
    )
}

export default SelectCompType
